import { def } from "../../../config";
import fetchServer from "../../fetchServer";

export default async function setWhitelistDomain(authAdmin, origin) {
  let result = { return: 0, msg: "Something went wrong fetching members!" };

  await fetchServer({
    method: "POST",
    url: `/setting/setCors?authorizationCode=${authAdmin}&origin=${origin}`,
    api: def.api?.replace("/api", ""),
  })
    .then((res) => {
      // console.log(" => ",res)
      if (res?.data && !res?.data?.error) {
        result = {
          return: 1,
          msg: "Successfull",
          data: res?.data?.allowedOrigins,
        };
      } else if (res?.data?.error) result["msg"] = res.data.error;
    })
    .catch((err) => {
      console.log("Network Error!");
    });

  return result;
}
